<kl-sms-logs-stream [smsId]="dialogData?.data?.smsId"></kl-sms-logs-stream>
